/**
 * call integration - Call Agent Status List
 */
const getDefaultState = () => {
  return {
    callAgentList: []
  }
}
const state = getDefaultState()

const getters = {
  callAgentList: (state) => {
    return state.callAgentList
  }
}

const actions = {
}

const mutations = {
  changeCallAgentList (state, callAgentList) {
    state.callAgentList = callAgentList
  },
  CLEAR_CALL_AGENT_LIST (state) {
    Object.assign(state, getDefaultState())
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/call/agentStatus.js